import { render, staticRenderFns } from "./GroundTruthTable.vue?vue&type=template&id=4d858355&scoped=true&"
import script from "./GroundTruthTable.vue?vue&type=script&lang=js&"
export * from "./GroundTruthTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d858355",
  null
  
)

export default component.exports